/* =======================================================================
   DERMALYS — HEADER GLOBAL (MODE NOIR PARTOUT / LANDING BLANC)
   ✅ Header NOIR partout (texte/icônes/logo noir) sauf landing (= home-like)
   ✅ Landing : BLANC au top, NOIR au hover (desktop) et au scroll
   ✅ Sync hauteurs banner/header -> CSS vars (submenu + mobile menu “respire”)
   ✅ Mega-menu hover + fallback .menu-open
   ✅ Mobile menu panels (Accueil, croix, overlay, retour, swipe-back)
   ➜ À coller TOUT EN BAS de custom-dermalys.js
   ======================================================================= */
(() => {
  'use strict';
  if (window.__DERMALYS_HEADER_GLOBAL__) return;
  window.__DERMALYS_HEADER_GLOBAL__ = true;

  const root   = document.documentElement;
  const body   = document.body;
  const header = document.getElementById('dermalys-header');
  if (!header) return;

  const burger  = document.getElementById('burger-toggle');
  const menu    = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mm-overlay');

  const THRESH = 10;

  const mqlDesk  = window.matchMedia('(min-width: 901px)');
  const mqlHover = window.matchMedia('(hover:hover) and (pointer:fine)');

  const isDesktopHover = () => mqlDesk.matches && mqlHover.matches;
  const isHomeLike = () => header?.dataset?.homeLike === 'true';

  const getBanner = () =>
    document.querySelector('.exo-top-banner') ||
    document.getElementById('exo-top-banner');

  const anySubmenuOpen = () =>
    !!document.querySelector('.dermalys-menu-item.show-submenu');

  /* ----------------------------
     MODE : noir partout sauf landing
  ----------------------------- */
  function applyBaseMode() {
    const home = isHomeLike();

    // Landing flags (tu t’en sers déjà ailleurs)
    root.classList.toggle('has-dermalys-landing', home);
    body.classList.toggle('der-home-like', home);

    // NOIR partout sauf landing
    header.classList.toggle('header-black', !home);

    // Nettoyage d’états résiduels
    if (!home) header.classList.remove('hovered'); // sur pages “noires”, pas besoin de hovered
  }

  /* ----------------------------
     MESURE : banner + header -> vars
  ----------------------------- */
  function syncHeights() {
    const banner = getBanner();
    const bannerH = banner ? Math.round(banner.getBoundingClientRect().height || 0) : 0;
    const headerH = Math.max(60, Math.round(header.getBoundingClientRect().height || 0));

    root.style.setProperty('--exo-banner-height', `${bannerH}px`);
    root.style.setProperty('--header-height-desktop', `${headerH}px`);
    root.style.setProperty('--header-height-mobile', `${headerH}px`);

    // variables “master”
    root.style.setProperty('--der-banner-h', `${bannerH}px`);
    root.style.setProperty('--der-header-h', `${headerH}px`);
    root.style.setProperty('--hero-top', `${bannerH + headerH}px`);

    root.style.setProperty('--der-stack-h', `${bannerH + headerH}px`);

    root.classList.toggle('has-exo-banner', bannerH > 0);
    body.classList.toggle('has-exo-banner', bannerH > 0);
  }

  /* ----------------------------
     SCROLL : scrolled (toutes pages)
     Landing : scrolled => noir
  ----------------------------- */
  function setScrolledState() {
    const y = window.scrollY || 0;
    const on = y > THRESH;
    header.classList.toggle('scrolled', on);
    if (on) header.classList.remove('hovered');
  }

  /* ----------------------------
     HOVER (landing uniquement)
     Landing : BLANC au top, NOIR au hover
  ----------------------------- */
  function setHovered(on) {
    if (!isHomeLike()) return;                 // uniquement landing
    if (!isDesktopHover()) return;             // uniquement desktop hover réel
    if ((window.scrollY || 0) > THRESH) return; // uniquement au top
    header.classList.toggle('hovered', !!on);
  }

  /* ----------------------------
     MENU OPEN (mega-menu + mobile menu)
  ----------------------------- */
  function setMenuOpenState(force = null) {
    const on = (force === null) ? anySubmenuOpen() : !!force;
    header.classList.toggle('menu-open', on);

    // Landing : si menu ouvert au top => on veut l’état “noir” (hovered)
    if (isHomeLike() && (window.scrollY || 0) <= THRESH) {
      if (on) header.classList.add('hovered');
      else if (!header.matches(':hover')) header.classList.remove('hovered');
    }
  }

  /* ----------------------------
     MEGA MENU : hover open/close
  ----------------------------- */
  function wireMegaMenuHover() {
    const items = Array.from(document.querySelectorAll('.dermalys-menu-item'));

    items.forEach((item) => {
      const submenu = item.querySelector('.submenu-fullwidth');
      if (!submenu) return;

      let t = null;

      const open = () => {
        clearTimeout(t);
        item.classList.add('show-submenu');
        setMenuOpenState(null);
        setHovered(true);
      };

      const close = () => {
        t = setTimeout(() => {
          item.classList.remove('show-submenu');
          setMenuOpenState(null);

          // landing : si plus rien d’ouvert, on retire hovered
          if (isHomeLike()) {
            setTimeout(() => {
              if (!anySubmenuOpen() && !header.matches(':hover') && (window.scrollY || 0) <= THRESH) {
                header.classList.remove('hovered');
              }
            }, 40);
          }
        }, 160);
      };

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      submenu.addEventListener('mouseenter', open);
      submenu.addEventListener('mouseleave', close);
    });

    // Hover sur items SANS sous-menu + icônes : landing => hovered au top
    const noSubmenuItems = items.filter(it => !it.querySelector('.submenu-fullwidth'));
    const iconLinks = Array.from(document.querySelectorAll('#dermalys-header .icons a'));

    const arm = (el) => {
      el.addEventListener('mouseenter', () => setHovered(true));
      el.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!anySubmenuOpen() && !header.matches(':hover') && (window.scrollY || 0) <= THRESH) {
            header.classList.remove('hovered');
          }
        }, 80);
      });
    };

    noSubmenuItems.forEach(arm);
    iconLinks.forEach(arm);

    // Hover global header (landing)
    header.addEventListener('mouseenter', () => setHovered(true));
    header.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!anySubmenuOpen() && (window.scrollY || 0) <= THRESH) header.classList.remove('hovered');
      }, 100);
    });

    // Focus clavier (landing)
    const focusables = [
      ...noSubmenuItems.map(i => i.querySelector('a')).filter(Boolean),
      ...iconLinks
    ];
    focusables.forEach((el) => {
      el.addEventListener('focus', () => setHovered(true), true);
      el.addEventListener('blur',  () => {
        setTimeout(() => {
          if (!anySubmenuOpen() && !header.matches(':hover') && (window.scrollY || 0) <= THRESH) {
            header.classList.remove('hovered');
          }
        }, 60);
      }, true);
    });
  }

  /* ----------------------------
     MOBILE MENU : panels + overlay + croix + swipe back
  ----------------------------- */
  function wireMobileMenu() {
    if (!burger || !menu) return;

    const PANELS = Array.from(menu.querySelectorAll('.mm-panel'));
    const ROOTP  = PANELS.find(p => p.dataset.panel === 'root');

    let stack = ['root'];
    let touchStartX = null, touchStartY = null, swiping = false;

    const panelByKey = (key) =>
      menu.querySelector(`.mm-panel[data-panel="${key}"]`) ||
      menu.querySelector(`#panel-${key}`);

    function setAria(open) {
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      try { menu.inert = !open; } catch (_) {}
      if (overlay) overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    function applyPanelStates() {
      PANELS.forEach(p => p.classList.remove('is-active','is-prev'));
      const activeKey = stack[stack.length - 1];
      const prevKey   = stack[stack.length - 2];
      const active = panelByKey(activeKey);
      const prev   = prevKey ? panelByKey(prevKey) : null;
      if (prev)   prev.classList.add('is-prev');
      if (active) active.classList.add('is-active');
    }

    function focusFirst(panel) {
      if (!panel) return;
      const f = panel.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
      if (f) f.focus({ preventScroll: true });
    }

    function openMenu() {
      menu.classList.add('show');
      root.classList.add('mm-open');
      body.classList.add('mm-open');
      setAria(true);

      // important : “respire sous le header” -> CSS gère via vars, nous on force menu-open
      header.classList.add('menu-open');
      burger.classList.add('is-open');

      requestAnimationFrame(() => {
        menu.style.visibility = 'visible';
        applyPanelStates();
        focusFirst(ROOTP);
      });
    }

    function closeMenu() {
      setAria(false);
      stack = ['root'];
      applyPanelStates();
      menu.classList.remove('show');
      root.classList.remove('mm-open');
      body.classList.remove('mm-open');
      menu.style.visibility = 'hidden';

      burger.classList.remove('is-open');
      burger.focus({ preventScroll: true });

      // on retire menu-open seulement si aucun mega-menu n’est ouvert
      setMenuOpenState(anySubmenuOpen());
    }

    function goTo(key) {
      const target = panelByKey(key);
      if (!target) return;
      stack.push(key);
      applyPanelStates();
      focusFirst(target);
    }

    function goBack() {
      if (stack.length <= 1) { closeMenu(); return; }
      stack.pop();
      applyPanelStates();
      focusFirst(panelByKey(stack[stack.length - 1]));
    }

    burger.addEventListener('click', () => {
      menu.classList.contains('show') ? closeMenu() : openMenu();
    });

    overlay?.addEventListener('click', closeMenu);
    const closeBtn = menu.querySelector('[data-mm-close]');
closeBtn?.addEventListener('click', (e) => {
  e.preventDefault();
  closeMenu();
});


    menu.addEventListener('click', (e) => {
      const goBtn = e.target.closest('[data-go]');
      if (goBtn) { goTo(goBtn.getAttribute('data-go')); return; }
      const backBtn = e.target.closest('[data-back]');
      if (backBtn) { goBack(); return; }
    });

    document.addEventListener('keydown', (e) => {
      if (!menu.classList.contains('show')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeMenu(); }
      if (e.key === 'Backspace' && e.target === document.body) { e.preventDefault(); goBack(); }
    }, true);

    // Swipe-back
    menu.addEventListener('touchstart', (e) => {
      if (!menu.classList.contains('show')) return;
      const t = e.touches[0];
      touchStartX = t.clientX; touchStartY = t.clientY; swiping = false;
    }, { passive: true });

    menu.addEventListener('touchmove', (e) => {
      if (touchStartX === null) return;
      const t = e.touches[0];
      const dx = t.clientX - touchStartX;
      const dy = Math.abs(t.clientY - touchStartY);
      if (dy > 24) return;
      if (dx > 28) swiping = true;
    }, { passive: true });

    menu.addEventListener('touchend', () => {
      if (swiping) goBack();
      touchStartX = touchStartY = null; swiping = false;
    });

    // Auto-close si on repasse desktop
    mqlDesk.addEventListener?.('change', (m) => {
      if (m.matches && menu.classList.contains('show')) closeMenu();
    });

    applyPanelStates();
    setAria(false);
  }

  /* ----------------------------
     RAF scroll handler
  ----------------------------- */
  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      setScrolledState();
      setMenuOpenState(null);
      ticking = false;
    });
  }

  /* ----------------------------
     BOOT
  ----------------------------- */
  applyBaseMode();
  syncHeights();
  setScrolledState();
  setMenuOpenState(null);

  wireMegaMenuHover();
  wireMobileMenu();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => requestAnimationFrame(() => {
    applyBaseMode();
    syncHeights();
    setScrolledState();
    setMenuOpenState(null);
  }), { passive: true });

  window.addEventListener('load', () => requestAnimationFrame(() => {
    applyBaseMode();
    syncHeights();
    setScrolledState();
    setMenuOpenState(null);
  }), { once: true, passive: true });

  // Observe tailles (header + banner)
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(() => requestAnimationFrame(syncHeights));
    ro.observe(header);
    const b = getBanner();
    if (b) ro.observe(b);
  }

  // Si banner injectée plus tard
  if ('MutationObserver' in window) {
    const mo = new MutationObserver(() => requestAnimationFrame(() => {
      applyBaseMode();
      syncHeights();
      setMenuOpenState(null);
    }));
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
    /* ----------------------------
     BFCache / Return-to-page FIX
     - Quand tu reviens sur la page (pageshow), iOS/Safari/Chrome peuvent restaurer
       avant que les vars CSS soient recalculées => header passe sous la bannière.
  ----------------------------- */
  function hardResync() {
    applyBaseMode();
    syncHeights();
    setScrolledState();
    setMenuOpenState(null);

    // double RAF = plus robuste (fonts/layout/badge cart peuvent bouger)
    requestAnimationFrame(() => {
      syncHeights();
      setScrolledState();
      setMenuOpenState(null);
    });
  }

  // ✅ BFCache (retour arrière / navigation)
  window.addEventListener('pageshow', (e) => {
    // toujours resync, et si BFCache (persisted) on resync encore après 1 tick
    requestAnimationFrame(hardResync);
    if (e.persisted) setTimeout(hardResync, 60);
  }, { passive: true });

  // ✅ Si l’onglet revient au premier plan (mobile / iOS)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) requestAnimationFrame(hardResync);
  }, { passive: true });

  // ✅ Quand la fenêtre reprend le focus (desktop)
  window.addEventListener('focus', () => requestAnimationFrame(hardResync), { passive: true });

})();

/* =========================================================
   DERMALYS — SAFETY RESET (iOS BFCache / states stuck)
   ========================================================= */
(function(){
  function hardCloseOverlays(){
    document.documentElement.classList.remove('mm-open');
    document.body.classList.remove('mm-open');

    const header = document.getElementById('dermalys-header');
    if(header) header.classList.remove('menu-open');

    const mm = document.getElementById('mobile-menu');
    if(mm){
      mm.classList.remove('show');
      mm.setAttribute('aria-hidden','true');
      mm.querySelectorAll('.mm-panel').forEach(p=>{
        p.classList.remove('is-active','is-prev');
      });
    }
  }

  window.addEventListener('pageshow', hardCloseOverlays);
  document.addEventListener('visibilitychange', function(){
    if(document.visibilityState === 'visible') hardCloseOverlays();
  });
  window.addEventListener('orientationchange', hardCloseOverlays);
})();
